// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__290-F","colMin":"styles_colMin__il9IX","colCheckbox":"styles_colCheckbox__3SGIw"};